import React from 'react';
import { useSelector } from 'react-redux';
import '../../css/Footer.css';

export default function Footer() {
  const { user } = useSelector((state) => state.auth);

  return (
    <div id="divallfooterid">
      <footer className="footer-3d">
        <div className="container">
          <p className="footer-brand">MBZ Transport</p>

          {user?.role !== 'driver' && (
            <p className="footer-contact">
              Support: <span className="fw-semibold">0337 8233366</span> &middot;
              <span className="fw-semibold"> support@mbztransport.com</span>
            </p>
          )}

          {user?.role === 'driver' && (
            <p className="footer-contact">
              Driver Helpline: <span className="fw-semibold">0337 8233366</span>
            </p>
          )}

          <a
            href="https://mbztransport.com/Terms-And-Agreement"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link d-block mb-3"
          >
            Terms &amp; Agreement
          </a>

          <p className="footer-copy">
            &copy; {new Date().getFullYear()} MBZ Transport. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
